import React, { PureComponent, memo, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'

import { Nav, NavDropdown } from 'react-bootstrap';
import HeaderEmpresa from './HeaderEmpresa/HeaderEmpresa.jsx';

 function Header(props) {
  return (
    <div>
    <HeaderEmpresa
      empresaId={props.empresaId}
      handlerEmpresas={props.handlerEmpresas}
      lstEmpresas={props.lstEmpresas}
      nombreSistema={props.nombreSistema}
    />
    </div>
  );
};
export default withRouter(memo(Header))